import React, { Component } from 'react'

export class Search extends Component {
    render() {
        return (
            <div className="App-Body">
                Search Page
            </div>
        )
    }
}

export default Search
